export default __webpack_public_path__ + "static/media/tkit-1-md.58620ac7.svg";